// extracted by mini-css-extract-plugin
export default {"section":"Birthday_section__36fux","container":"Birthday_container__b5no2","container__photo":"Birthday_container__photo__71EMN","photo":"Birthday_photo__12UJX"};